import { Form, Select } from 'antd'
import { FC } from 'react'
import { requiredRules } from '../../../../../../../../../../constants/forms/validation/rules'
import { stampOrderOrderStatuses } from '../../../../../../../../../../constants/entity-enums/stamp-order-order-statuses'

interface OrderStatusProps {}

const OrderStatus: FC<OrderStatusProps> = () => {
    return (
        <Form.Item name={'orderStatus'} label={'Статус заказа'} rules={requiredRules}>
            <Select options={stampOrderOrderStatuses.map(value => ({ value }))} />
        </Form.Item>
    )
}

export default OrderStatus
